import { z } from "zod";

const envSchema = z.object({
  VITE_APP_ENV: z.enum(["local", "staging", "production"]).default("local"),
  VITE_SUPABASE_URL: z.url().default("http://127.0.0.1:54321"),
  VITE_SUPABASE_PUBLISHABLE_KEY: z
    .string()
    .min(1)
    .default("local-publishable-key-not-configured"),
  VITE_FEATURE_ADMIN: z.stringbool().default(true),
  VITE_FEATURE_EDITOR: z.stringbool().default(true),
  VITE_FEATURE_PUBLICATION: z.stringbool().default(true),
  VITE_TELEMETRY_ENDPOINT: z.string().optional(),
  VITE_ERROR_REPORTING_ENDPOINT: z.string().optional(),
});

export const env = envSchema.parse(import.meta.env);

export const featureFlags = {
  admin: env.VITE_FEATURE_ADMIN,
  editor: env.VITE_FEATURE_EDITOR,
  publication: env.VITE_FEATURE_PUBLICATION,
} as const;
